const React = require('react')

function NullComponent() {
  return null
}

module.exports = {
  __esModule: true,
  CameraScreen: NullComponent,
  Camera: NullComponent,
  // Some code imports the package default; keep it defined.
  default: {
    CameraScreen: NullComponent,
    Camera: NullComponent,
  },
}

